import * as React from 'react';
import * as Formik from 'formik';
import { getDropdownOptions } from '../constants';
import { CredentialField, CredentialSchema } from '../types';
import FormikInputField from './FormikInputField';
import { FormGroup, Label } from 'reactstrap';

type Props = {
  field: CredentialField;
  subfields: CredentialField[];
  schema: CredentialSchema;
  isEdit: boolean;
};

const MultiInputField = ({ field, subfields, schema, isEdit }: Props) => {
  const { setFieldValue, values } = Formik.useFormikContext<{
    [key: string]: string;
  }>();

  const handleSelectChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const value = evt.target.value;
    setFieldValue(values[field.name], '');
    setFieldValue(field.name, value);
  };

  // Clear default values, if present
  React.useEffect(() => {
    if (!isEdit) {
      subfields
        .filter((subfield) => subfield.name != values[field.name])
        .forEach((subfield) => setFieldValue(subfield.name, ''));
    }
  }, [subfields, isEdit]);

  const currentSubfield = subfields.find(
    (subfield) => subfield.name == values[field.name],
  );
  let subfieldElement;
  if (currentSubfield !== undefined) {
    const options = getDropdownOptions(currentSubfield, schema.name);
    subfieldElement = (
      <Formik.Field
        component={FormikInputField}
        options={options}
        name={currentSubfield.name}
        label={currentSubfield.display_name}
        description={currentSubfield.description}
        dataType={options ? 'select' : currentSubfield.data_type}
        sensitive={currentSubfield.sensitive}
        isEdit={isEdit}
        paddingBottom={10}
        noAutoComplete
      />
    );
  }

  return (
    <>
      <Formik.Field name={field.name}>
        {() => (
          <FormGroup style={{ marginBottom: '0.5rem' }}>
            <Label for={field.name}>{field.display_name}</Label>
            {field.description ? (
              <span className="description">{field.description}</span>
            ) : null}
            <Label>
              {subfields.map((subfield: CredentialField) => {
                return (
                  <span className="mr-4" key={subfield.name}>
                    <input
                      name={field.name}
                      type="radio"
                      className="mr-1"
                      checked={values[field.name] === subfield.name}
                      key={subfield.name}
                      value={subfield.name}
                      onChange={handleSelectChange}
                    />
                    {subfield.display_name}
                  </span>
                );
              })}
            </Label>
          </FormGroup>
        )}
      </Formik.Field>
      {subfieldElement}
    </>
  );
};

export default MultiInputField;
